import $ from 'jquery';

$(document).ready(() => {
  const emailFromSender = $('.emailFromSender_input');
  const emailFromSenderChk = $('.emailFromSender_check');
  // input field for emailFromSender should not be visible
  $(emailFromSender).closest('.frm__row').hide();

  // if user checks 'yes, i want a copy of this form to my mail-address...'
  $(emailFromSenderChk).on('click', () => {
    $(emailFromSenderChk).delay(100).queue(() => {
      if ($(emailFromSenderChk).closest('.frm__row').find('.emailFromSender_check').is(':checked')) {
        // ... then, copy value of input.email in our hidden field
        $(emailFromSender).val($('.email').val());
      } else {
        // if user un-check the box, a default-value for cms has to be there
        $(emailFromSender).val('no-reply@example.com');
      }
      $(emailFromSenderChk).dequeue();
    });
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/form-email2sender.js